export const contactInterestOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Selling inventory', label: 'Selling inventory' },
  { value: 'Buying inventory', label: 'Buying inventory' },
  { value: 'Fulfillment services (FBO)', label: 'Fulfillment services (FBO)' },
  {
    value: 'Software Solutions (Tradegrid)',
    label: 'Software Solutions (Tradegrid)',
  },
  { value: 'Platform integration', label: 'Platform integration' },
  { value: 'Partnership opportunities', label: 'Partnership opportunities' },
  { value: 'Something else', label: 'Something else' },
];
